import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <motion.header 
        initial={{ y: -100 }}
        animate={{ y: 0 }}
        transition={{ duration: 0.5 }}
        className="fixed top-6 left-0 right-0 z-50 flex justify-center px-4"
      >
        <nav 
          className={`
            relative flex items-center justify-between w-full max-w-5xl px-6 py-3
            rounded-full transition-all duration-300
            ${isScrolled ? 'bg-white/80 shadow-lg backdrop-blur-md border border-gray-200/50' : 'bg-white/50 backdrop-blur-sm border border-transparent'}
          `}
          style={{
            boxShadow: isScrolled ? '0 8px 32px rgba(0, 0, 0, 0.08)' : 'none',
          }}
        >
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3">
            <img src="/assets/img/logo.png" alt="Easy Hiring Logo" className="h-8 w-auto object-contain" />
            <span className="font-display font-bold text-lg tracking-tight text-gray-900">Easy Hiring</span>
          </Link>

          {/* Desktop Links */}
          <div className="hidden md:flex items-center gap-8">
            <Link to="/#services" className="text-sm font-medium text-gray-600 hover:text-blue-600 transition-colors">Services</Link>
            <Link to="/#approach" className="text-sm font-medium text-gray-600 hover:text-blue-600 transition-colors">Our Approach</Link>
            <Link to="/#testimonials" className="text-sm font-medium text-gray-600 hover:text-blue-600 transition-colors">Success Stories</Link>
            <Link to="/#faq" className="text-sm font-medium text-gray-600 hover:text-blue-600 transition-colors">FAQ</Link>
          </div>

          {/* CTA Button */}
          <div className="hidden md:flex items-center gap-4">
            <Link to="/contact" className="text-sm font-medium text-gray-600 hover:text-blue-600 transition-colors">Contact Us</Link>
            <Link to="/contact" className="bg-gray-900 text-white hover:bg-black text-sm font-medium px-5 py-2.5 rounded-full transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-0.5">
              Hire Talent
            </Link>
          </div>

          {/* Mobile Menu Toggle */}
          <button 
            className="md:hidden p-2 text-gray-600 hover:text-blue-600 transition-colors"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </nav>
      </motion.header>

      {/* Mobile Menu Overlay */}
      <AnimatePresence>
        {isMobileMenuOpen && (
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            className="fixed top-24 left-4 right-4 z-40 p-6 bg-white/95 backdrop-blur-xl rounded-2xl shadow-2xl border border-gray-100 flex flex-col gap-4 md:hidden"
          >
            <Link to="/#services" className="text-base font-medium text-gray-800 py-2 border-b border-gray-100" onClick={() => setIsMobileMenuOpen(false)}>Services</Link>
            <Link to="/#approach" className="text-base font-medium text-gray-800 py-2 border-b border-gray-100" onClick={() => setIsMobileMenuOpen(false)}>Our Approach</Link>
            <Link to="/#testimonials" className="text-base font-medium text-gray-800 py-2 border-b border-gray-100" onClick={() => setIsMobileMenuOpen(false)}>Success Stories</Link>
            <Link to="/#faq" className="text-base font-medium text-gray-800 py-2 border-b border-gray-100" onClick={() => setIsMobileMenuOpen(false)}>FAQ</Link>
            <div className="flex flex-col gap-3 mt-2">
              <Link to="/contact" className="w-full py-3 rounded-xl border border-gray-200 font-medium text-center text-gray-700 hover:bg-gray-50" onClick={() => setIsMobileMenuOpen(false)}>Contact Us</Link>
              <Link to="/contact" className="w-full py-3 rounded-xl bg-blue-600 text-white font-medium text-center hover:bg-blue-700 shadow-lg shadow-blue-500/30" onClick={() => setIsMobileMenuOpen(false)}>Hire Talent</Link>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default Header;
